import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
  birthdateMonth: Yup.number('Month must be a number')
    .min(1, 'Must be greater than 0')
    .max(12, 'Must be less than 13')
    .required('Required'),
  birthdateDay: Yup.number('Day must be a number')
    .min(1, 'Must be greater than 0')
    .max(31, 'Must be less than 32')
    .required('Required'),
  birthdateYear: Yup.number()
    .required('Required')
    .min(1908)
    .max(2018),
  gender: Yup.string().required('Required'),
  raceEthnicHeritage: Yup.string().required('Required'),
  currentPosition: Yup.object().shape({
    seniority: Yup.string().required('Required'),
    title: Yup.string().required('Required'),
    company: Yup.object().shape({
      industry: Yup.string().required('Required'),
      size: Yup.string().required('Required'),
    }),
  }),
  languages: Yup.array().required('Required'),
  educationLevel: Yup.string().required('Required'),
  workStatus: Yup.array().required('Required'),
  annualHouseholdIncome: Yup.string().required('Required'),
  country: Yup.string().required('Required'),
  state: Yup.string().when('country', {
    is: 'us',
    then: () => Yup.string().required('Required'),
    otherwise: () => Yup.string().notRequired(),
  }),
  paypalAccount: Yup.string().email('Invalid email').required('Required'),
  recruitingProgram: Yup.boolean(),
  jobsSelected: Yup.array().min(1, 'Select one job role'),
});
